import Vector2 from "./Vector2";

export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
}
export type AppTouchEvent = TouchEvent;

export default class MouseEventArgs {
  private _screenPosition: Vector2;
  private _worldPosition: Vector2;
  private _button: MouseButton;
  private _wheelDelta: number;

  public get screenPosition(): Vector2 {
    return this._screenPosition;
  }

  public get worldPosition(): Vector2 {
    // console.log("this._worldPosition", this._worldPosition);
    return this._worldPosition;
  }

  public get button(): MouseButton {
    return this._button;
  }

  public get wheelDelta(): number {
    return this._wheelDelta;
  }

  public constructor(
    screenPosition: Vector2,
    worldPosition: Vector2,
    button: MouseButton,
    wheelDelta = 0
  ) {
    this._screenPosition = screenPosition;
    this._worldPosition = worldPosition;
    this._button = button;

    this._wheelDelta = wheelDelta;
  }
}
